import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { module } from 'modujs';
import { lazyLoadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        setTimeout(() => {
            this.initTimeline()
        }, 300)
    }

    initTimeline() {
        this.$('image').forEach((item) => {
            lazyLoadImage(item, null, () => {})
        })

        if(window.isMobile || window.innerWidth <= 1000) return

        gsap.registerPlugin(ScrollTrigger);

        const sections = Array.from(this.$('item'));
        let maxWidth = 0;

        const getMaxWidth = () => {
            maxWidth = 0;
            sections.forEach((section) => {
                maxWidth += section.offsetWidth;
            });
        };
        getMaxWidth();

        ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

        gsap.to(sections, {
            x: () => `-${maxWidth - window.innerWidth}`,
            ease: "none",
            scrollTrigger: {
                trigger: this.el,
                pin: true,
                scrub: true,
                end: () => `+=${maxWidth}`,
                invalidateOnRefresh: true,
                horizontal: window.isMobile
            }
        });

        sections.forEach((sct, i) => {
            ScrollTrigger.create({
                trigger: sct,
                start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
                end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
                toggleClass: {targets: sct, className: "active"}
            });
        });
    }

    destroy() {
        super.destroy();
        ScrollTrigger?.removeEventListener("refreshInit");
    }
}
